// extracted by mini-css-extract-plugin
export default {"popup":"owner-editor_popup__xxwbw","buttons":"owner-editor_buttons__z8qFA","button":"owner-editor_button__wWT9y","error":"owner-editor_error__tprmi"};